var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.componentStyle.comp,
    _vm._g(
      _vm._b(
        {
          tag: "component",
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b({ attrs: { icon: "" } }, "v-btn", attrs, false),
                      on
                    ),
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            content: _vm.totalCombined,
                            color: _vm.totalCombined ? "soli-red" : null,
                            overlap: "",
                            bordered: !!_vm.totalCombined,
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "text-shadow-blue",
                              attrs: {
                                color:
                                  _vm.$page.component == "Explore"
                                    ? "white"
                                    : "accent",
                              },
                            },
                            [_vm._v("chat_bubble_outline")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        "component",
        { ..._vm.componentStyle.props },
        false
      ),
      _vm.componentStyle.on
    ),
    [
      _vm._v(" "),
      _c(
        "v-sheet",
        [
          _c(
            "v-container",
            [
              _c(
                "v-tabs",
                {
                  staticClass: "px-1",
                  attrs: { grow: "" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    [
                      _vm.$page.props.unreadInboxTotal.messages
                        ? _c(
                            "v-badge",
                            {
                              attrs: {
                                content:
                                  _vm.$page.props.unreadInboxTotal.messages,
                                color: "soli-red",
                              },
                            },
                            [_vm._v("Messages")]
                          )
                        : _c("div", [_vm._v("Messages")]),
                    ],
                    1
                  ),
                  _c(
                    "v-tab",
                    [
                      _vm.$page.props.unreadInboxTotal.notifications
                        ? _c(
                            "v-badge",
                            {
                              attrs: {
                                content:
                                  _vm.$page.props.unreadInboxTotal
                                    .notifications,
                                color: "soli-red",
                              },
                            },
                            [_vm._v("Notifications")]
                          )
                        : _c("div", [_vm._v("Notifications")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("v-tab-item", [_c("InboxMessages")], 1),
                  _vm._v(" "),
                  _c("v-tab-item", [_c("InboxNotifications")], 1),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }